import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '@/services/CredentialsService.js'

const EventsRepository = RepositoryFactory.get('event')

class EventService {
  static async getEvents (params) {
    try {
      return await EventsRepository.getEvents(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }

  static async getEvent (eventId, params) {
    try {
      return await EventsRepository.getEvent(CredentialsService.getCurrentTenantId(), eventId, params)
    } catch (error) {
      console.log(error)
    }
  }

  static async updateEvent (eventId, data) {
    try {
      return await EventsRepository.updateEvent(CredentialsService.getCurrentTenantId(), eventId, data)
    } catch (error) {
      console.log(error)
    }
  }

  static async createEvent (data) {
    try {
      return await EventsRepository.createEvent(CredentialsService.getCurrentTenantId(), data)
    } catch (error) {
      console.log(error)
    }
  }

  static async downloadEventSummary (eventId, params) {
    try {
      return await EventsRepository.downloadEventSummary(eventId, params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default EventService
